<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="personProfileAudits && personProfileAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list (nextPage)="onNextPage()" [audits]="personProfileAudits">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Person Profile audits </ng-template>
</ng-template>
